import moment from "moment-timezone";
import { PaXFlowInitialState } from "../../store/pax-flow/passengerFlowSlice";

export function getUpdatedSlotTime(name: string) {
  const slotTimeBandArr = name?.split("|");
  const [start] = slotTimeBandArr;
  const slotStartTime = moment(start, moment.ISO_8601);
  const slotStartTimeFormatted = slotStartTime.format("hh:mm");
  const [, end] = slotTimeBandArr;
  const slotEndTime = moment(end, moment.ISO_8601);
  const slotEndTimeFormatted = slotEndTime.format("hh:mm");

  return slotStartTime.isValid() && slotEndTime.isValid()
    ? `${slotStartTimeFormatted}-${slotEndTimeFormatted}`
    : name;
}

export function getUpdatedPaxTouchPointData(
  index: number,
  paxFlowState: PaXFlowInitialState
) {
  const {
    touchPointTableDataArray,
    touchPointTableColumnsArray,
    touchPointChartDataArray,
  } = paxFlowState;
  const touchPointData = touchPointTableDataArray[index]?.data;
  const touchPointColumns = touchPointTableColumnsArray[index];
  const touchPointChartData = touchPointChartDataArray[index];

  const updatedTouchPointColumns = touchPointColumns?.map((column) => {
    const isHeaderShowHide = true;
    const { key, name, maxWidth, minWidth, fieldName } = column;
    let updatedName = name;
    let updatedMaxWidth = maxWidth;
    let updatedMinWidth = minWidth;

    const className = `column-${name}`;
    if (name === "factors") {
      updatedName = "Factors";
      updatedMaxWidth = 149;
    }

    if (name !== "factors" && name !== "threshold") {
      updatedMaxWidth = 99;
      updatedMinWidth = 99;
      updatedName = getUpdatedSlotTime(name);
    }

    return {
      key: key,
      fieldName,
      name: updatedName,
      maxWidth: updatedMaxWidth,
      minWidth: updatedMinWidth,
      isHeaderShowHide,
      className,
    };
  });

  return {
    updatedTouchPointColumns: updatedTouchPointColumns,
    touchPointData: touchPointData,
    touchPointChartData: touchPointChartData,
  };
}

export function getTimeSeries(dataArr: any[]) {
  return dataArr.reduce(function (result: any, current: any) {
    return Object.assign(result, current);
  }, {});
}

export function getMappedTableData(mappedData: any) {
  if (!mappedData?.length) {
    return [];
  }

  return mappedData?.map((item: any) => {
    const touchpointArray = item?.map((itemInner: any) => {
      const { key, factors, threshold, data } = itemInner;
      const dataArr = data.map((item: any) => {
        const fieldItem = Object.values(item);
        const { value, status } = mapFieldItem(fieldItem) ?? {};

        const [key] = Object.keys(item);

        return {
          [key]: `${value}${status ? "|" : ""}${status}`,
        };
      });

      const timeSeries = getTimeSeries(dataArr);

      return {
        key,
        factors,
        threshold,
        ...timeSeries,
      };
    });
    return {
      data: touchpointArray,
    };
  });
}

export function mapFieldItem(fieldItem: any[]) {
  return fieldItem?.map((fv: any) => {
    return {
      value: fv.value,
      status: fv.status,
    };
  })[0];
}
